export const campaign = {
  field: {
    id: 'ID',
    name: 'Title',
    status: 'Status',
    skills: 'Take into account the skills of operators',
    type: 'Type',
    time: 'min',
    attempt: 'Attempt',
    operator: 'Operators',
    percent_lost_calls: 'Percentage of lost calls',
    operators: 'Add operators',
    url: 'URL',
    weight: 'Campaign weight',
    max_time: 'Maximum waiting time (sec.)',
    asr: 'Fixed ASR',
    asr_default: 'Default ASR',
    resetAsr: 'Auto reset ASR',
    avg_task: 'Average task duration (sec.)',
    dt_calls: 'DT Affecting calls',
    lost_calls: 'Bounce calculation period (min.)',
    wait_operator: 'Pending operator (sec.)',
    record: 'Record calls',
    sort: 'Sorting tasks',
    direction: 'Direction',
    instance: 'Server',
    max_attempts: 'Attempts',
    attempts_interval_min: 'Time between attempts (min.)',
    calls_limit: 'Number of simultaneous calls',
    caller_id: 'Caller ID',
    pbx_number: 'Virtual PBX Number',
    empty_data: 'No relevant data available',
    select_or_type: 'Select or type',
    machine_detection: {
      duration: 'Duration (sec.)',
      mode: 'Mode',
      on_threshold: 'Hangup call',
      threshold: 'Threshold value (%)'
    },
    welcome_message: 'Welcome message'
  },

  answering_machine: 'Answering machine',

  select: {
    mode: {
      notification: 'Notification',
      aggressive: 'Aggressive'
    },
    type: {
      synchronous: 'Synchronous',
      asynchronous: 'Asynchronous'
    }
  },

  sort: {
    type: {
      priority: 'Priority',
      attempts: 'Attempts',
      lead_date: 'Order creation date'
    },
    order: {
      asc: 'Ascending',
      desc: 'Descending'
    }
  },
  welcome_message: {
    success: 'Media file uploaded successfully',
    modal_title: 'Select or upload a media file'
  },

  tooltips: {
    welcome_message:
      'You can upload a media file that the client will hear before the operator joins the call.',
    welcome_message_with_instance: 'You can only use a media file for a specific server.',
    welcome_message_with_select_instance:
      'You can only use a media file for a specific server. Select a server.',
    weight:
      'Used to define the order of the campaign. If one operator works with several campaigns, then the tasks of the campaign with the highest weight are processed first.',
    avg_task: 'Includes time for talking with clients and time for working with a client card.',
    dt_calls:
      "The number of calls, on the basis of which the dialing duration is calculated in seconds from the moment of initiation to the client's answer.",
      empty_data: 'Database is empty',
      need_support: 'Export of numbers from the database is currently unavailable. Please contact support',
    fix_asr:
      'A strictly defined ASR value that will not change during the entire campaign. Other ASR settings are ignored',
    wait_operator:
      "The threshold value for how long the client waits for the operator's response. Introduced to separate customers who tried to wait for a response from customers who immediately dropped the call.",
    sort:
      'Allows you to sort campaign tasks by priority, order creation date, number of attempts. It is possible to indicate the direction of sorting. Using the cursor, you can change the order by adding, dragging and dropping sorting criteria.',
    max_time: 'The maximum waiting time for the client to answer the call',
    sync_type:
      'Synchronous type. Client will first be connected to AMD, and only after analyzing the call, the connection to the operator will occur.',
    async_type:
      'Asynchronous type. Client will instantly be connected to the operator, AMD determiner works in the background.',
    duration:
      'Set the acceptable time for defining an autoresponder. The most accurate result is achieved 7 seconds after the call is processed by AMD.',
    mode:
      'Notification mode. AMD will record the result of call processing in statistics, but will not automatically drop the call. Agressive mode. AMD will record the result of call processing in statistics and drop the call when the specified threshold value is reached.',
    threshold: 'When the specified value is reached, the call will end.',
    drop_call:
      'The setting allows you to independently end calls when answering machine are detected.',
    hangup_cause_code: {
      1: 'Unallocated (unassigned) number',
      2: 'No route to specified transmit network',
      3: 'No route to destination',
      5: ' Misdialled trunk prefix (national use)',
      6: 'Channel unacceptable',
      7: ' Call awarded and being delivered in an established channel',
      8: 'Preemption',
      14: 'QoR: ported number',
      16: 'Normal Clearing',
      17: 'User busy',
      18: 'No user responding',
      19: 'No answer from user (user alerted)',
      20: 'Subscriber absent',
      21: 'Call Rejected',
      22: 'Number changed',
      23: 'Redirected to new destination',
      26: 'Non-selected user clearing',
      27: 'Destination out of order',
      28: 'Invalid number format',
      29: 'Facility rejected',
      30: 'Response to STATUS ENQUIRY',
      31: 'Normal, unspecified',
      34: 'No circuit/channel available',
      38: 'Network out of order',
      41: 'Temporary failure',
      42: 'Switching equipment congestion',
      43: 'Access information discarded',
      44: 'Requested circuit/channel not available',
      50: 'Requested facility not subscribed',
      52: 'Outgoing call barred',
      54: 'Incoming call barred',
      57: 'Bearer capability not authorized',
      58: 'Bearer capability not presently available',
      65: 'Bearer capability not implemented',
      66: 'Channel type not implemented',
      69: 'Requested facility not implemented',
      81: 'Invalid call reference value',
      88: 'Incompatible destination',
      95: 'Invalid message unspecified',
      96: 'Mandatory information element is missing',
      97: 'Message type non-existent or not implemented',
      98: 'Message not compatible with call state or message type non-existent or not implemented',
      99: 'Information element nonexistent or not implemented',
      100: 'Invalid information element contents',
      101: 'Message not compatible with call state',
      102: 'Recover on timer expiry',
      111: 'Protocol error, unspecified',
      127: 'Interworking, unspecified'
    },
    caller_id: 'You need to buy a number or add your own. To do this, go to the'
  },

  table: {
    action: {
      show_detail_stat: 'View statistics',
      create: 'Add Campaign'
    }
  },

  filter: {
    status: {
      title: '@:autocaller_v2.campaign.field.status',
      active: 'Active',
      not_active: 'Inactive'
    },

    type: {
      title: '@:autocaller_v2.campaign.field.type',
      predictive: 'Predictive',
      progressive: 'Progressive'
    },

    name: {
      title: '@:autocaller_v2.campaign.field.name'
    },

    pbx_number: {
      title: '@:autocaller_v2.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autocaller_v2.campaign.field.caller_id'
    }
  },

  modal: {
    remove: {
      content: `Are you sure you want to delete the campaign <b>{name}<b>?`
    },

    change_status: {
      enable: 'Are you sure you want to start auto-dialing?',
      disable: 'Are you sure you want to stop auto-dialing?'
    },

    notice_pbx_module_required: {
      content:
        'To create predictive dialer campaigns, activate "<strong>the virtual PBX service</strong>"',
      ok: 'Connect'
    }
  },

  create: {
    title: '@:autocaller_v2.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autocaller_v2.breadcrumb.campaign.edit'
  },

  form: {
    title: 'Basic information',
    parameters: 'Campaign options',
    settings: 'Additional settings',
    determinant: 'Answering Machine Detection',
    recipients_title: 'Recipients',
    save_btn: 'Save',
    update_btn: 'Update'
  }
};
